/*
 *
 * SurveyTranslationPage constants
 *
 */

export const FETCH_TRANSLATIONS =
  'app/SurveyTranslationsPage/FETCH_TRANSLATIONS';
export const FETCH_TRANSLATIONS_SUCCESS =
  'app/SurveyTranslationsPage/FETCH_TRANSLATIONS_SUCCESS';
export const FETCH_TRANSLATIONS_ERROR =
  'app/SurveyTranslationsPage/FETCH_TRANSLATIONS_ERROR';

export const STORE_TRANSLATIONS =
  'app/SurveyTranslationsPage/STORE_TRANSLATIONS';
export const STORE_TRANSLATIONS_SUCCESS =
  'app/SurveyTranslationsPage/STORE_TRANSLATIONS_SUCCESS';
export const STORE_TRANSLATIONS_ERROR =
  'app/SurveyTranslationsPage/STORE_TRANSLATIONS_ERROR';

export const ADD_LANGUAGE = 'app/SurveyTranslationsPage/ADD_LANGUAGE';
export const SELECT_LANGUAGE = 'app/SurveyTranslationsPage/SELECT_LANGUAGE';
export const REMOVE_LANGUAGE = 'app/SurveyTranslationsPage/REMOVE_LANGUAGE';
export const UPDATE_QUESTION = 'app/SurveyTranslationsPage/UPDATE_QUESTION';
export const UPDATE_ANSWER = 'app/SurveyTranslationsPage/UPDATE_ANSWER';

export const GOOGLE_TRANSLATE = 'app/SurveyTranslationsPage/GOOGLE_TRANSLATE';
export const MODAL_GOOGLE_TRANSLATE_OPEN =
  'app/SurveyTranslationsPage/MODAL_GOOGLE_TRANSLATE_OPEN';
export const MODAL_GOOGLE_TRANSLATE_CANCEL =
  'app/SurveyTranslationsPage/MODAL_GOOGLE_TRANSLATE_CANCEL';

export const GOOGLE_TRANSLATE_SUCCESS =
  'app/SurveyTranslationsPage/GOOGLE_TRANSLATE_SUCCESS';
export const GOOGLE_TRANSLATE_ERROR =
  'app/SurveyTranslationsPage/GOOGLE_TRANSLATE_ERROR';
export const UPDATE_TRANSLATE_OPEN_ENDED =
  'app/SurveyTranslationsPage/UPDATE_TRANSLATE_OPEN_ENDED';

export const UPDATE_GROUP_ATTRIBUTE =
  'app/SurveyTranslationsPage/UPDATE_GROUP_ATTRIBUTE';

export const IMPORT_TRANSLATIONS =
  'app/SurveyTranslationsPage/IMPORT_TRANSLATIONS';

export const ATTRIBUTES_KEY = 'attributes';
export const ATTRIBUTE_VALUES_KEY = 'attributeValues';

export const CONJOINT_TEXT_VALUES_KEYS = {
  [ATTRIBUTES_KEY]: 'name',
  [ATTRIBUTE_VALUES_KEY]: 'text',
};

export const ANSWER_TYPE = {
  COLUMN: 'column',
  TICK: 'tick',
  BIPOLAR_BEFORE: 'bipolarBefore',
  BIPOLAR_AFTER: 'bipolarAfter',
  MATRIX_ANSWER_BEFORE: 'matrixAnswerBefore',
  MATRIX_COLUMN_BEFORE: 'matrixColumnBefore',
  ROW: 'row',
};
